module.exports = __webpack_public_path__ + "802cd4771283c06ed0b50110c24ac310.png";